"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfInquiryOrderProductEditViewModel = instanceOfInquiryOrderProductEditViewModel;
exports.InquiryOrderProductEditViewModelFromJSON = InquiryOrderProductEditViewModelFromJSON;
exports.InquiryOrderProductEditViewModelFromJSONTyped = InquiryOrderProductEditViewModelFromJSONTyped;
exports.InquiryOrderProductEditViewModelToJSON = InquiryOrderProductEditViewModelToJSON;
exports.InquiryOrderProductEditViewModelToJSONTyped = InquiryOrderProductEditViewModelToJSONTyped;
/**
 * Check if a given object implements the InquiryOrderProductEditViewModel interface.
 */
function instanceOfInquiryOrderProductEditViewModel(value) {
    return true;
}
function InquiryOrderProductEditViewModelFromJSON(json) {
    return InquiryOrderProductEditViewModelFromJSONTyped(json, false);
}
function InquiryOrderProductEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'iopDetailNo': json['iopDetailNo'] == null ? undefined : json['iopDetailNo'],
        'iopOrgId': json['iopOrgId'] == null ? undefined : json['iopOrgId'],
        'oName': json['oName'] == null ? undefined : json['oName'],
        'iopFormNo': json['iopFormNo'] == null ? undefined : json['iopFormNo'],
        'iopMaterialNo': json['iopMaterialNo'] == null ? undefined : json['iopMaterialNo'],
        'mdProduct': json['mdProduct'] == null ? undefined : json['mdProduct'],
        'ciCompanyName': json['ciCompanyName'] == null ? undefined : json['ciCompanyName'],
        'psProductSeriesName': json['psProductSeriesName'] == null ? undefined : json['psProductSeriesName'],
        'iopMaterialColorNo': json['iopMaterialColorNo'] == null ? undefined : json['iopMaterialColorNo'],
        'pcsColorStyleName': json['pcsColorStyleName'] == null ? undefined : json['pcsColorStyleName'],
        'iopSpec': json['iopSpec'] == null ? undefined : json['iopSpec'],
        'pssSpecificationName': json['pssSpecificationName'] == null ? undefined : json['pssSpecificationName'],
        'iopOrderQuantity': json['iopOrderQuantity'] == null ? undefined : json['iopOrderQuantity'],
        'iopMemoDesc': json['iopMemoDesc'] == null ? undefined : json['iopMemoDesc'],
        'iopUpDate': json['iopUpDate'] == null ? undefined : json['iopUpDate'],
        'iopOriginalPrice': json['iopOriginalPrice'] == null ? undefined : json['iopOriginalPrice'],
        'iopMaterialPrice': json['iopMaterialPrice'] == null ? undefined : json['iopMaterialPrice'],
        'iopDiscountValue': json['iopDiscountValue'] == null ? undefined : json['iopDiscountValue'],
    };
}
function InquiryOrderProductEditViewModelToJSON(json) {
    return InquiryOrderProductEditViewModelToJSONTyped(json, false);
}
function InquiryOrderProductEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'iopDetailNo': value['iopDetailNo'],
        'iopOrgId': value['iopOrgId'],
        'oName': value['oName'],
        'iopFormNo': value['iopFormNo'],
        'iopMaterialNo': value['iopMaterialNo'],
        'mdProduct': value['mdProduct'],
        'ciCompanyName': value['ciCompanyName'],
        'psProductSeriesName': value['psProductSeriesName'],
        'iopMaterialColorNo': value['iopMaterialColorNo'],
        'pcsColorStyleName': value['pcsColorStyleName'],
        'iopSpec': value['iopSpec'],
        'pssSpecificationName': value['pssSpecificationName'],
        'iopOrderQuantity': value['iopOrderQuantity'],
        'iopMemoDesc': value['iopMemoDesc'],
        'iopUpDate': value['iopUpDate'],
        'iopOriginalPrice': value['iopOriginalPrice'],
        'iopMaterialPrice': value['iopMaterialPrice'],
        'iopDiscountValue': value['iopDiscountValue'],
    };
}
